import { render, staticRenderFns } from "./EssSwaps.vue?vue&type=template&id=518ed03e"
import script from "./EssSwaps.vue?vue&type=script&lang=js"
export * from "./EssSwaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports